export const ApiBookingCalculations = (axios, obuBaseUrl) => {
  axios.setBaseURL(obuBaseUrl)

  const save = async (bookingCode, payload) => {
    const result = await axios.post(`/api/booking-calculations/${bookingCode}`, payload)
    return result.data
  }

  const load = async (bookingCode) => {
    const result = await axios.get(`/api/booking-calculations/${bookingCode}`)
    return result.data
  }

  return {
    bookingCalculationsLoad: load,
    bookingCalculationsSave: save
  }
}
